import {
  bifeChorizo,
  asado,
  vacio,
  costillasCerdo,
  bondiola,
  provoleta,
  papasFritas,
  pure,
  ensalada,
  huevosFritos,
  bunuelos,
  chinchu,
  mollejas,
  rinon,
  pollo,
  matrimonio,
  panquequeDulce,
  panquequeManzana,
  flan,
  almendrado,
  helado,
  choriHuevo,
} from "./img/images"

const menu = [
  {
    id: 1,
    title: "Bife de Chorizo",
    category: "carnes",
    price: 15.99,
    img: bifeChorizo,
    desc: `I'm baby woke mlkshk wolf bitters live-edge blue bottle, hammock freegan copper mug whatever cold-pressed `,
  },
  {
    id: 2,
    title: "Asado",
    category: "carnes",
    price: 13.99,
    img: asado,
    desc: `vaporware iPhone mumblecore selvage raw denim slow-carb leggings gochujang helvetica man braid jianbing. Marfa thundercats `,
  },
  {
    id: 3,
    title: "Vacío",
    category: "carnes",
    price: 6.99,
    img: vacio,
    desc: `ombucha chillwave fanny pack 3 wolf moon street art photo booth before they sold out organic viral.`,
  },
  {
    id: 4,
    title: "Costillitas de cerdo",
    category: "carnes",
    price: 20.99,
    img: costillasCerdo,
    desc: `Shabby chic keffiyeh neutra snackwave pork belly shoreditch. Prism austin mlkshk truffaut, `,
  },
  {
    id: 5,
    title: "Bondiola",
    category: "carnes",
    price: 22.99,
    img: bondiola,
    desc: `franzen vegan pabst bicycle rights kickstarter pinterest meditation farm-to-table 90's pop-up `,
  },
  {
    id: 6,
    title: "Provoleta",
    category: "acompañamientos",
    price: 8.99,
    img: provoleta,
    desc: `Portland chicharrones ethical edison bulb, palo santo craft beer chia heirloom iPhone everyday`,
  },
  {
    id: 7,
    title: "papas fritas",
    category: "acompañamientos",
    price: 8.99,
    img: papasFritas,
    desc: `carry jianbing normcore freegan. Viral single-origin coffee live-edge, pork belly cloud bread iceland put a bird `,
  },
  {
    id: 8,
    title: "pure",
    category: "acompañamientos",
    price: 3.99,
    img: pure,
    desc: `on it tumblr kickstarter thundercats migas everyday carry squid palo santo leggings. Food truck truffaut  `,
  },
  {
    id: 9,
    title: "ensalada lechuga y tomate",
    category: "acompañamientos",
    price: 1.5,
    img: ensalada,
    desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
  },
  {
    id: 10,
    title: "huevos fritos",
    category: "acompañamientos",
    price: 1.99,
    img: huevosFritos,
    desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
  },
  {
    id: 11,
    title: "buñuelos de acelga",
    category: "acompañamientos",
    price: 3.6,
    img: bunuelos,
    desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
  },
  {
    id: 12,
    title: "chinchulines",
    category: "achuras",
    price: 6.99,
    img: chinchu,
    desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
  },
  {
    id: 13,
    title: "mollejas",
    category: "achuras",
    price: 7.5,
    img: mollejas,
    desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
  },
  {
    id: 14,
    title: "riñones",
    category: "achuras",
    price: 6.66,
    img: rinon,
    desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
  },
  {
    id: 15,
    title: "pollo",
    category: "carnes",
    price: 10.25,
    img: pollo,
    desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
  },
  {
    id: 16,
    title: "choripan + huevo frito",
    category: "carnes",
    price: 5.25,
    img: choriHuevo,
    desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
  },
  {
    id: 17,
    title: "chorizo/morcilla",
    category: "carnes",
    price: 9.5,
    img: matrimonio,
    desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
  },
  {
    id: 18,
    title: "flan casero mixto",
    category: "postres",
    price: 2.5,
    img: flan,
    desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
  },
  {
    id: 19,
    title: "panqueque dulce de leche",
    category: "postres",
    price: 3.5,
    img: panquequeDulce,
    desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
  },
  {
    id: 20,
    title: "panqueque manzana al rhum",
    category: "postres",
    price: 4.25,
    img: panquequeManzana,
    desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
  },
  {
    id: 21,
    title: "almendrado con charlotte",
    category: "postres",
    price: 2.25,
    img: almendrado,
    desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
  },
  {
    id: 22,
    title: "bochas de helado",
    category: "postres",
    price: 2.25,
    img: helado,
    desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
  },
]

export default menu
